import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/HistoryHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/ReferralsWrapper/index.tsx");
